export default __webpack_public_path__ + "static/media/returnIcon.8ca56ee9.svg";